<template>
  <div class="row stat-primary stat-charts">
    <div class="col-12 col-md-4" v-for="chart in charts" :key="chart.title">
      <router-link :to="{ name: chart.link }">
        <ChartCard
          subtitle="15 days"
          :title="chart.title"
          :total="chart.total"
          :data="chart.series" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash-es'

import ChartCard from '@/components/ChartCard.vue'

export default {
  props: {
    link: String,
    items: Array
  },
  components: {
    ChartCard
  },
  computed: {
    ...mapState(['events']),
    chartOptions: function () {
      return { fill: '#fff', stroke: '#2CB1BC', strokeWidth: 2, width: '100%' }
    },
    emptyCharts: function () {
      return this.items.map(item => {
        return {
          title: item.title
        }
      })
    },
    charts: function () {
      if (!this.events) return this.emptyCharts

      return this.items.map(item => {
        const series = this.getSeries(item)
        const total = series.reduce((acc, val) => acc + val, 0)

        return {
          title: item.title,
          series: series.toString(),
          total,
          link: item.link || this.link
        }
      })
    }
  },
  methods: {
    getSeries: function (item) {
      if (item.key.includes('*')) {
        const key1 = item.key.replace('.*', '')
        const key2 = key1.replace(/_/g, '')

        const arr1 = this.events.map(d => Object.values(get(d, key1, {})).reduce((acc, val) => acc + val, 0))
        const arr2 = this.events.map(d => Object.values(get(d, key2, {})).reduce((acc, val) => acc + val, 0))

        return arr1.map((a, idx) => a + arr2[idx])
      }

      return this.events.map(d => get(d, item.key, 0))
    }
  }
}
</script>
